<template>
    <v-app id="inspire" class="gb">
        <v-content>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="10" md="7">
                        <v-card class="elevation-12 pt-5 pb-10 px-10 card-theme">
                            <v-card-text>
                                <h1 class="my-4 azul-header">Sign Up</h1>
                                <v-alert
                                        :value="true"
                                        color="#19A99D"
                                        style="color: white; margin: 0 0.5rem 0 1rem; border-radius: 1rem"
                                        class="alert-login-vendor mt-12"
                                >
                                    <strong>
                                        <h3 class="mb-3">Congratulations!!</h3>
                                    </strong>
                                    <p>
                                        You have been invited to participate in the KIEY application
                                        by:
                                        <br/>
                                        <strong style="font-size: 18px">RYAN DALLAS REAL ESTATE</strong>
                                    </p>
                                    <p>
                                        Please ensure the cell phone number listed below is correct
                                        before activating your account.
                                    </p>
                                    <p>
                                        If this is not your correct cell phone number, please notify Ryan
                                        Dallas Real Estate for correction.
                                    </p>
                                </v-alert>
                                <v-form class="padd-log mx-auto" style="width: 60%;">
                                    <ValidationProvider
                                            name="phone_number"
                                            rules="required"
                                            v-slot="{ errors, valid }"
                                    >
                                        <v-text-field
                                                v-model="phoneNumber"
                                                v-mask="mask"
                                                :error-messages="errors"
                                                :success="valid"
                                                class="ui-label"
                                                label="Username (Cell Phone Number)"
                                                name="phone_number"
                                                type="text"
                                                width="660px"
                                                required
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        color="#29ABE2"
                                        height="49px"
                                        class="btn-t"
                                        letter-spacing="0.94px"
                                        rounded
                                        depressed
                                        @click="showSkipA = true"
                                >ACTIVATE
                                </v-btn>
                            </v-card-actions>
                            <p class="text-center mt-8">
                                Already have an account?
                                <router-link to="/" style="text-decoration: none" class="login-class">Login
                                </router-link>
                            </p>
                            <div class="sombra"></div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

            <v-dialog v-model="showSkipA" width="706px">
                <!-- <template v-slot:activator="{ on }"> </template> -->
                <div class="modal">
                    <v-row>
                        <v-col class="icon-modal few table-cell">

                        </v-col>
                        <v-col class="table-cell modal-content">
                            <div class="d-flex justify-space-between">
                                <h6 class="modal-title mb-5">Onboarding Complete!</h6>
                            </div>
                            <div class="content_cont_modal">
                                <p>
                                    <b>You're ready to go!</b>
                                </p>

                                <p>
                                    If you did not list yourself as a user then you still have access to the admin panel
                                    by <br>
                                    logging in at admin.kiey.com. Your login is the cell phone number you used when signing up.
                                </p>

                                <p>
                                    If you are also a user, then <b>download the mobile app from the app store</b>, you
                                    can also<br>
                                    access the desktop version of the app by logging in at <b>web.kiey.com</b>. Your
                                    login is the<br>
                                    cell phone number you used when signing up.
                                </p>

                                <p>
                                    We highly recommend you wait until all agents and vendors are on the system
                                    before<br>
                                    inviting homeowners. To add homeowners on behalf of your agents, go to "Agents" in the Admin
                                    Panel,<br>
                                    and copy the appropriate Agent URL to send to your homeowners.
                                </p>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn class="btn-azul big mt-6" rounded depressed @click="showSkipA = false">HOME PAGE
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-dialog>
        </v-content>
    </v-app>
</template>

<script>
    import {mask} from "vue-the-mask";
    import {ValidationProvider} from "vee-validate";

    export default {
        name: "Login",
        directives: {
            mask
        },
        data: () => ({
            mask: "### - ### - ####",
            phoneNumber: "",
            email: ""
        }),
        props: {
            showSkipA: {
                default: false
            }
        },
        components: {
            ValidationProvider
        },
        methods: {}
    };
</script>

<style scoped>
    /* estilo para pregunta */
    .azul {
        color: #000000;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: -0.31px;
        margin-right: 11px;
    }

    /* estilo para h1 */
    .azul-header {
        color: #041332;
        font-size: 25px;
        font-weight: 700;
        line-height: 34px;
    }

    /* estilo para link ContactUs*/
    .azul-contact {
        font-size: 15px;
        font-weight: 700;
    }

    /* estilo para texto debajo de login */
    .v-application .py-2 {
        color: #878787;
        font-size: 15px;
        font-weight: 500;
    }

    .btn-t {
        width: 155px;
        height: 48px;
        color: white;
        box-shadow: 0 5px 18px rgba(51, 51, 51, 0.13);
        border-radius: 24px;
        margin: 0 auto;
    }

    .ui-label {
        color: #061d47;
        /*!important;*/
        font-size: 20px !important;
        font-weight: bold !important;
    }

    .padd-log {
        padding: 0 65px;
    }

    .card-theme {
        -webkit-box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
        -moz-box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
        box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
    }

    .v-input__control {
        width: 34px;
    }

    .fa-theme--a {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #29abe2;
        font-size: 10px !important;
    }

    @media (max-width: 768px) {
        .v-application .px-10 {
            padding-left: 0px !important;
            padding-right: 0px !important;
        }

        .padd-log {
            padding: 0;
        }
    }
</style>
